export default __webpack_public_path__ + "static/media/handsomenew.410f076b.png";